// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

export const WebPromptConsent = dynamic(() => import('./WebPromptConsent').then(mod => mod.WebPromptConsent));

export const WebPromptConsentConfig = {
  emptyLabel: 'WebPromptConsent',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/webpromptconsent`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const WebPromptConsentEditable = (props: any) => (
  <EditableComponent config={WebPromptConsentConfig} {...props}>
    <WebPromptConsent {...props} />
  </EditableComponent>
);
